import coursesApi from "../../../../pages/catalog/assets/js/core/api"
import { createLogger, LogLevel } from "../utils/logger"

const logger = createLogger("CatalogModalsAPI", LogLevel.INFO)

logger.info("API модуль catalog-modals инициализирован")

const proxy = new Proxy(coursesApi, {
  get(target, prop, receiver) {
    if (prop === "getRawCourseById") {
      return function (id) {
        const currentDomain = window.location.hostname;
        const indexName = currentDomain === 'dev-wp.100points.ru' ? 'preprod_100points_courses' : 'prod_100points_courses';
        const apiUrl = `https://search.100points.ru/${indexName}/_doc/${id}/_source`;
        
        return fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
          .then((res) => {
            if (!res.ok)
              throw new Error(`Ошибка API: ${res.status} ${res.statusText}`)
            return res.json()
          })
          .then((data) => {
            logger.info("Получен курс по id через api.php:", data)
            return data
          })
          .catch((err) => {
            logger.error("Ошибка при получении курса по id через api.php:", err)
            throw err
          })
      }
    }
    const orig = target[prop]
    if (typeof orig === "function") {
      return function (...args) {
        logger.info(`Вызов API: ${String(prop)}`, args)
        try {
          const result = orig.apply(this, args)
          if (result instanceof Promise) {
            return result
              .then((data) => {
                logger.info(`Ответ API (${String(prop)}):`, data)
                return data
              })
              .catch((err) => {
                logger.error(`Ошибка API (${String(prop)}):`, err)
                throw err
              })
          } else {
            logger.info(`Ответ API (${String(prop)}):`, result)
            return result
          }
        } catch (err) {
          logger.error(`Ошибка API (${String(prop)}):`, err)
          throw err
        }
      }
    }
    return orig
  },
})

export default proxy
